import { Plus, RefreshCw } from 'lucide-react'

import { Button, SelectField } from '@krp/ui-kit'

import { InputField } from '../../../shared/ui/InputField'
import { OneCQueryState } from '../../../shared/ui/OneCQueryState'
import type { SupplyStatus } from '../model/types'
import type { SuppliesListActions, SuppliesListVm } from '../model/viewModels'
import { StatusBadge } from './StatusBadge'
import '../../../shared/ui/onec.css'
import '../../pricing/ui/onec-ui.css'
import './supplies.css'

/**
 * Список поставок ОДНОЙ базы (rid окна). Фильтр — намерение этой базы; строки —
 * снимок курсора службы с моментом чтения. Открытие поставки — окно с тем же rid.
 */
export function SuppliesListScreen({ vm, actions }: { vm: SuppliesListVm; actions: SuppliesListActions }) {
  return (
    <section className="onec-screen" aria-label="Поставки 1С">
      <div className="onec-toolbar">
        <h2>Поставки</h2>
        <Button variant="primary" icon={<Plus size={16} aria-hidden="true" />} onClick={actions.create}>
          Новая поставка
        </Button>
        <Button variant="secondary" onClick={actions.openReceipts}>
          Приходные в 1С
        </Button>
        <Button variant="ghost" icon={<RefreshCw size={16} aria-hidden="true" />} onClick={actions.reload}>
          Обновить
        </Button>
      </div>
      <div className="onec-row">
        <SelectField
          label="Статус"
          value={vm.filter.status}
          options={vm.statusOptions}
          onChange={(value) => actions.filterChanged({ status: value as SupplyStatus | '' })}
        />
        <InputField label="Номер" value={vm.filter.number} onChange={(number) => actions.filterChanged({ number })} />
      </div>
      <OneCQueryState query={vm.query} emptyText="Поставок нет" onRetry={actions.reload} />
      {vm.rows.length > 0 && (
        <>
          {vm.observedAt !== null && <p className="onec-muted">Список на {vm.observedAt}</p>}
          <ul className="onec-list">
            {vm.rows.map((row) => (
              <li key={row.id}>
                <Button variant="ghost" onClick={() => actions.open(row.id)}>
                  <strong>{row.number}</strong> · {row.documentDate} · {row.supplierName}
                </Button>
                <StatusBadge badge={row.badge} />
                <span className="onec-list__meta">
                  {row.warehouseName || 'склад не выбран'} · строк {row.linesCount} · {row.amount}
                  {row.supplierInvoiceNumber !== null ? ` · накладная ${row.supplierInvoiceNumber}` : ''}
                </span>
              </li>
            ))}
          </ul>
          {vm.canLoadMore && (
            <Button variant="secondary" onClick={actions.loadMore}>
              Показать ещё
            </Button>
          )}
        </>
      )}
    </section>
  )
}
